import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["leftContent", "leftContentMinWidth", "rightContent", "rightContentMinWidth"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const StyledHeaderDetails = styled.div.withConfig({
  displayName: "HeaderDetails__StyledHeaderDetails",
  componentId: "sc-1sjn885-0"
})(({
  theme,
  $cssStyles
}) => {
  return Object.assign({
    display: 'flex',
    flexWrap: 'wrap',
    flexGrow: 1,
    marginLeft: `-${theme.space[600]}`,
    maxWidth: 'none',
    minHeight: theme.space[25],
    padding: `0 ${theme.space[600]} 0 0`,
    width: `calc(100% + ${parseFloat(theme.space[600]) * 2}px)`
  }, $cssStyles);
});
const DetailsBox = styled.div.withConfig({
  displayName: "HeaderDetails__DetailsBox",
  componentId: "sc-1sjn885-1"
})(["flex-basis:", "px;flex-grow:", ";flex-shrink:", ";margin:", ";"], props => props.$basis, props => props.$grow, props => props.$shrink, ({
  theme
}) => `0 0 ${theme.space[400]} ${theme.space[600]}`);
export const HeaderDetails = _ref => {
  let {
      leftContent,
      leftContentMinWidth = 233,
      rightContent,
      rightContentMinWidth = 200
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsxs(StyledHeaderDetails, {
    $cssStyles: cssStyles,
    children: [/*#__PURE__*/_jsx(DetailsBox, {
      $basis: leftContentMinWidth,
      $grow: 1,
      $shrink: 0,
      children: leftContent
    }), /*#__PURE__*/_jsx(DetailsBox, {
      $basis: rightContentMinWidth,
      $grow: 9999,
      $shrink: 1,
      children: rightContent
    })]
  });
};